import { HealthService } from './../services/health.service';
import { Container } from './../interfaces/container';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-health-check',
  templateUrl: './health-check.component.html',
  styleUrls: ['./health-check.component.scss']
})
export class HealthCheckComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
	@ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;

	ColumnMode = ColumnMode;
	columns = [
    { prop: 'name', name: 'Nom <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'status', name: 'État <i class="fa fa-sort sort-icon"></i></span>' },
    { prop: 'vmid', name: 'Identifiant <i class="fa fa-sort sort-icon"></i></span>' },
		// { prop: 'btn_show', name: 'Voir les informations' },
	];

  tempTable = [];
  dataTable: Array<any>;
	searchField: string = "";
	columnSearch: string = "name";

  ticket: string;
  node: string = "PDEV1";

  constructor(
    private toastrService: ToastrService,
    private healthService: HealthService,
  ) { }

  ngOnInit(): void {
    this.getStatus();
  }
  
	ngAfterViewInit(): void {
		this.fixBrowserTooltip();
	}

  resetSearch() {
    this.searchField = "";
		this.getStatus();
	}

  onSearchChange() {
    const val = this.searchField;

    const temp = this.tempTable.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    this.dataTable = temp;
    this.table.offset = 0;
	}

  getAccessTicket(){
    this.blockUI.start('Loading');

    const data = {
      username: "root@pam",
      password: "lhMdCQQ98ELmptyk"
    };

    this.healthService.getAccessTicket(data).subscribe(
      (res) => {
        console.log(res);
        if (res.success){
          this.ticket = res.data.ticket;
          this.blockUI.stop();
        }
        else{
          this.blockUI.stop();
          if (res.errorSet.includes('INVALID_PARAMS')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');
					} else {
						this.toastrService.error('Une erreur s\'est produite');
					}
        }
      }, 
      (error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
    );
  }

  getStatus(){
    this.getStatusMongo();
    this.getStatusPIM();
    this.getStatusCore();
    // this.getAccessTicket();
    this.getAllContainers();
  }

  getStatusPIM(){
    this.blockUI.start('Loading');

    this.healthService.getStatusPIM().subscribe(
      (res) => {
        if (res.success){
          this.tempTable = [...this.tempTable,
            {
              "name": "API de PIM",
              "status": (res.data.status === 'running') ? "en cours" : "terminé",
            }
          ];
          this.dataTable = this.tempTable;
          this.blockUI.stop();
        }
        else {
          this.blockUI.stop();
          if (res.errorSet.includes('INVALID_PARAMS')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');
					} else {
						this.toastrService.error('Une erreur s\'est produite');
					}
        }
      }, 
      (error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
    );
  }

  getStatusCore(){
    this.blockUI.start('Loading');

    this.healthService.getStatusCore().subscribe(
      (res) => {
        if (res.success){
          this.tempTable = [...this.tempTable,
            {
              "name": "API de Core",
              "status": (res.data.status === 'running') ? "en cours" : "terminé",
            }
          ];
          this.dataTable = this.tempTable;
          this.blockUI.stop();
        }
        else {
          this.blockUI.stop();
          if (res.errorSet.includes('INVALID_PARAMS')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');
					} else {
						this.toastrService.error('Une erreur s\'est produite');
					}
        }
      }, 
      (error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
    );
  }

  getStatusMongo(){
    this.blockUI.start('Loading');

    this.healthService.getStatusMongo().subscribe(
      (res) => {
        if (res.success){
          this.tempTable = [...this.tempTable,
            {
              "name": "MongoDB",
              "status": (["connected", "connecting"].includes(res.data.status)) ? "connecté" : "terminé",
            }
          ];
          this.dataTable = this.tempTable;
          this.blockUI.stop();
        }
        else {
          this.blockUI.stop();
          if (res.errorSet.includes('INVALID_PARAMS')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');
					} else {
						this.toastrService.error('Une erreur s\'est produite');
					}
        }
      }, 
      (error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
    );

  }

  getAllContainers(){    
    this.blockUI.start('Loading');

    const data = {
      node: this.node,
      ticket: this.ticket,
    }

    this.blockUI.stop();

    this.tempTable = [
      {
        "status": "running",
        "netout": 22231807377,
        "maxmem": 2147483648,
        "swap": 0,
        "name": "MongoDB-DEV2",
        "maxdisk": "34359738368",
        "pid": "19324",
        "maxswap": 2147483648,
        "type": "lxc",
        "cpu": 0.00126409206793608,
        "vmid": "970",
        "disk": "1011220480",
        "lock": "",
        "mem": 274452480,
        "diskread": 0,
        "diskwrite": 0,
        "netin": 16727119162,
        "template": "",
        "cpus": 4,
        "uptime": 14408657
    },
    {
        "name": "rmm-wp-1",
        "swap": 0,
        "maxmem": 4294967296,
        "status": "running",
        "netout": 30829284740,
        "pid": "7825",
        "maxdisk": "10737418240",
        "vmid": "963",
        "cpu": 0,
        "maxswap": 4294967296,
        "type": "lxc",
        "disk": "1082785792",
        "lock": "",
        "diskwrite": 0,
        "diskread": 0,
        "mem": 194924544,
        "template": "",
        "netin": 129126061044,
        "uptime": 3654739,
        "cpus": 4
    },
    {
        "template": "",
        "netin": 9110152128,
        "diskwrite": 0,
        "diskread": 0,
        "mem": 158924800,
        "uptime": 3629825,
        "cpus": 4,
        "pid": "30715",
        "maxdisk": "8589934592",
        "name": "rmm-api-1",
        "swap": 0,
        "maxmem": 4294967296,
        "status": "running",
        "netout": 4847671597,
        "lock": "",
        "disk": "1624899584",
        "vmid": "959",
        "cpu": 0.000365168904265612,
        "type": "lxc",
        "maxswap": 4294967296
    },
    {
        "maxswap": 4294967296,
        "type": "lxc",
        "cpu": 0,
        "vmid": "961",
        "lock": "",
        "disk": "0",
        "netout": 0,
        "status": "stopped",
        "maxmem": 4294967296,
        "swap": 0,
        "name": "rmm-api-2",
        "maxdisk": "8589934592",
        "cpus": 4,
        "uptime": 0,
        "mem": 0,
        "diskread": 0,
        "diskwrite": 0,
        "netin": 0,
        "template": ""
    },
    {
        "diskwrite": 0,
        "diskread": 0,
        "mem": 160559104,
        "template": "",
        "netin": 4599189441,
        "uptime": 3654013,
        "cpus": 4,
        "name": "rmm-wp-2",
        "swap": 0,
        "maxmem": 4294967296,
        "netout": 1410188694,
        "status": "running",
        "pid": "27677",
        "maxdisk": "10737418240",
        "vmid": "965",
        "cpu": 0,
        "maxswap": 4294967296,
        "type": "lxc",
        "disk": "847904768",
        "lock": ""
    },
    {
        "netin": 7190221271,
        "template": "",
        "mem": 131624960,
        "diskwrite": 0,
        "diskread": 0,
        "cpus": 4,
        "uptime": 3725799,
        "maxdisk": "8589934592",
        "pid": "22911",
        "netout": 4624766162,
        "status": "running",
        "maxmem": 4294967296,
        "swap": 0,
        "name": "rmm-lb",
        "lock": "",
        "disk": "1035206656",
        "type": "lxc",
        "maxswap": 4294967296,
        "cpu": 0,
        "vmid": "964"
    },
    {
        "maxdisk": "107374182400",
        "pid": "8293",
        "netout": 94014532359,
        "status": "running",
        "maxmem": 2147483648,
        "swap": 0,
        "name": "share-dev",
        "lock": "",
        "disk": "1666842624",
        "maxswap": 2147483648,
        "type": "lxc",
        "cpu": 0,
        "vmid": "966",
        "netin": 29843304263,
        "template": "",
        "mem": 43757568,
        "diskread": 0,
        "diskwrite": 0,
        "cpus": 2,
        "uptime": 3649065
    },
    {
        "mem": 849068032,
        "diskread": 0,
        "diskwrite": 0,
        "netin": 31879392531,
        "template": "",
        "cpus": 8,
        "uptime": 14408690,
        "status": "running",
        "netout": 221893688591,
        "maxmem": 4194304000,
        "swap": 0,
        "name": "MySQL-DEV",
        "maxdisk": "34359738368",
        "pid": "11761",
        "type": "lxc",
        "maxswap": 4194304000,
        "cpu": 0,
        "vmid": "950",
        "disk": "1365639168",
        "lock": ""
    }
    ];
    this.dataTable = this.tempTable;
    this.dataTable.forEach( vm => (vm.status === "running") ? vm.status = "en cours" : vm.status = "terminé")
    // this.collectionSize += this.dataTable.length;
  }

  fixBrowserTooltip(): void {
		let headerTitle = document.querySelectorAll('.datatable-header-cell');

		headerTitle.forEach(element => {

			let title = element.getAttribute('title');
			element.setAttribute('title', title.replace('<i class="fa fa-sort sort-icon"></i></span>', ''));
			
		});
		
	}

}
